import React, { FC } from 'react';
import SectionTitle from './SectionTitle';
import AppIcon from './AppIcon';
import { services } from '../data/profile';

const Services: FC = () => (
  <section id="servicos" className="section section--alt">
    <div className="container">
      <SectionTitle
        eyebrow="Serviços"
        title="O que eu posso fazer por você"
        subtitle="Da ideia ao produto no ar, com acompanhamento em cada etapa."
      />
      <div className="grid grid--4">
        {services.map((s, i) => (
          <article key={s.title} className="card service reveal" style={{ transitionDelay: `${i * 70}ms` }}>
            <span className="icon-tile"><AppIcon name={s.icon} size={24} /></span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
